import { Box, styled } from "@mui/material";
import { FiMinusCircle } from "react-icons/fi";

export const MinusIcon = styled(FiMinusCircle)(() => ({
  color: "#F04438",
  marginTop: "20px",
}));

export const DeleteButton = styled(Box)(() => ({
  height: "100%",
}));
